// extracted by mini-css-extract-plugin
export default {"currentUserData":"CurrentUserData_currentUserData__hIc0Y"};